import { Injectable } from "@angular/core";
import { round, sum } from "lodash";
import { LinkedDiscountDTO } from "../shared/interfaces/discount.interface";

@Injectable({
    providedIn: 'root'
})

export class DiscountService {

    SubTotal: any;
    TaxableTotal: any;
    TotalTax: any;
    RemainingSubTotal: any;

    constructor() {
    }

    MapDiscounts(linkedDiscounts: any[]) {
        return linkedDiscounts?.map((g: any) => ({ ...(g.DiscountEntity ? (g.DiscountEntity || g) as LinkedDiscountDTO : g), TaxableDiscount: g.TaxableDiscount || 0, IsDiscountFromEstimate: g.IsDiscountFromEstimate || false, DiscountedValue: g.DiscountedValue || 0, EstimateDetailId: g.EstimateDetailId || null })) || [];
    }

  CalculateDiscount(subTotal: any, taxableTotal: any, totalTax: any, taxPercent: any, discounts: any[], checkAllowed: boolean = false) {
    this.SubTotal = subTotal || 0;
    this.TaxableTotal = taxableTotal || 0;
    this.TotalTax = totalTax || 0;
    let taxableGapDueToDiscount = 0;

    if (Array.isArray(discounts) && discounts.length > 0) {
      this.DiscountCalculator(discounts, checkAllowed);

      // let PercentDiscountBeforeTax = round(sum(discounts?.filter(d => d.ApplyBeforeTax && d.IsPercentage && !d.IsDiscountFromEstimate)?.map(f => (f.Value || 0) / 100) || 0), 2);
      // let DollerDiscountBeforeTax = round(sum(discounts?.filter(d => d.ApplyBeforeTax && !d.IsPercentage && !d.IsDiscountFromEstimate)?.map(f => f.Value || 0) || 0), 2);

      let PercentDiscountBeforeTax = round(sum(discounts.filter(d => d.ApplyBeforeTax && d.IsPercentage && !d.IsDiscountFromEstimate)?.map(f => (f.Value || 0) / 100) || []), 2);
      let DollerDiscountBeforeTax = round(sum(discounts.filter(d => d.ApplyBeforeTax && !d.IsPercentage && !d.IsDiscountFromEstimate)?.map(f => f.Value || 0) || []), 2);


      if (discounts.some(f => f.ApplyBeforeTax) == true) {

        //#region  calculating taxable discount from invoice discount that are not from estimate and also calculating the total tax gap.

        let totalTaxableDiscountFromInvoiceDiscounts = 0;
        discounts.forEach(d => {
          if (d.ApplyBeforeTax && !d.IsDiscountFromEstimate) {
            d.TaxableDiscount = (Math.abs(this.TaxableTotal) / Math.abs(this.SubTotal)) * d.DiscountedValue;
            totalTaxableDiscountFromInvoiceDiscounts += d.TaxableDiscount || 0;
          }
        });

        if (totalTaxableDiscountFromInvoiceDiscounts > 0 && (taxPercent || 0) > 0) {
          taxableGapDueToDiscount = round((totalTaxableDiscountFromInvoiceDiscounts * taxPercent) / 100, 2);
        }

        //#endregion

        let reducedTaxFromEstimate = round(sum(discounts.filter(f => f.IsDiscountFromEstimate).map(d => d.TaxableDiscount || 0) || []), 2);

        this.TaxableTotal = this.TaxableTotal -
          ((Math.abs(this.TaxableTotal) / Math.abs(this.SubTotal)) * (DollerDiscountBeforeTax + (Math.abs(this.SubTotal) * PercentDiscountBeforeTax)))
          - reducedTaxFromEstimate;

        if ((taxPercent || 0) > 0)
          this.TotalTax = round((this.TaxableTotal * taxPercent) / 100, 2);
      }
    }

    let DiscountValue = round(sum(discounts?.map(f => f.DiscountedValue || 0)), 2);

    return {
      DiscountValue: DiscountValue,
      TaxableTotal: this.TaxableTotal,
      TotalTax: this.TotalTax,
      TaxableGapDueToDiscount: taxableGapDueToDiscount,
      // Discounts are deliberately allowed to exceed the document subtotal.
      IsExceeded: false,
    }
  }

  DiscountCalculator(discounts: any[], checkAllowed: boolean) {
    discounts.filter(d => d.IsPercentage).forEach((dis: any) => {
      dis.DiscountedValue ||= 0;
      if (!dis.IsDiscountFromEstimate) {
        dis.DiscountedValue = this.CalculateDiscountedValue(dis, this.SubTotal);
      }
    });

    discounts.filter(d => !d.IsPercentage).forEach((dis: any) => {
      dis.DiscountedValue ||= 0;
      dis.DiscountedValue = dis.Value || dis.DiscountedValue;
    });
  }

  CalculateDiscountedValue(data: any, subTotal: any) {
    if (data.Value > 0) {
      let value = data.Value;
      if (data.IsPercentage) {
        value = Math.abs(subTotal) * (data.Value / 100);
      }
      return value;
    }

    return 0;
  }
}